export default "__VITE_ASSET__IOrgV9$2__"